// HomePage.js - Create the HomePage component
import React, { useEffect, useState } from "react";
import { Container, Row, Col, Button, Card, ListGroup } from "react-bootstrap";
import "./style.css";
import Backdrop from "../../Components/Backdrop";

import VideoPlayer from "../../Components/VideoPlayer";

import jamesImage from "../../assets/image/image-james.avif";
import savejamesBG from "../../assets/image/savejamesbg.avif";
import LandscapeTabs from "../../Components/LandscapeTabView";
import SaveJamesSection from "../../Components/InfoCards";
import GalleryLayout from "../../Components/Gallery";
import { useNavigate } from "react-router-dom";
import { FaTwitter, FaYoutube } from "react-icons/fa";
import { FaDiscord, FaTelegramPlane, FaTiktok } from "react-icons/fa";

function HomePage() {
  const [isMobile, setIsMobile] = useState(false);
  const navigate = useNavigate();

  const links = [
    {
      name: "TikTok",
      url: "https://www.tiktok.com/@savejamessolana",
      icon: <FaTiktok />,
      variant: "dark",
    },
    {
      name: "Discord",
      url: "https://discord.gg/dhJwCHgP",
      icon: <FaDiscord />,
      variant: "primary",
    },
    {
      name: "Telegram",
      url: "https://t.co/Z09ur309CR",
      icon: <FaTelegramPlane />,
      variant: "info",
    },
    {
      name: "Twitter",
      url: "https://x.com/SaveJamesSolana",
      icon: <FaTwitter />,
      variant: "secondary",
    },
  ];

  // Hook to update the screen size on resize
  useEffect(() => {
    const handleResize = () => {
      // Use matchMedia to detect mobile view
      setIsMobile(window.matchMedia("(max-width: 768px)").matches);
    };

    window.addEventListener("resize", handleResize);
    handleResize(); // Call once to set initial state

    return () => window.removeEventListener("resize", handleResize);
  }, []);

  return (
    <div
      className="homepage"
      style={{
        backgroundColor: "#121212",
        color: "#ffffff",
        minHeight: "100vh",
      }}
    >
      {!isMobile && (
        <Container fluid>
          <Backdrop />
        </Container>
      )}
      {!isMobile && (
        <Container className="py-5 main-wrapper">
          <img
            src={savejamesBG}
            alt="savejames"
            className="save-james-banner-text"
          />
          <img src={jamesImage} alt="savejames" className="save-jms-img" />
        </Container>
      )}
      <div
        className="section section-dark"
        style={{ backgroundColor: "black", padding: "50px 20px" }}
      >
        <Container>
          <Row>
            <Col md={8}>
              {/* <Row className="text-center mb-4">
                <Col>
                  <h2 className="display-4">
                    How{" "}
                    <span style={{ color: "rgb(255 119 40)" }}>$SAVEJAMES</span>{" "}
                    Started
                  </h2>
                </Col>
              </Row> */}
              <Row>
                <Col>
                  <p
                    style={{
                      fontSize: "1.2rem",
                      lineHeight: "1.8",
                      textAlign: "justify",
                    }}
                  >
                    It is a story about a deep-hearted connection between a
                    father and a son.
                    <a
                      href="https://x.com/JeffYoungerShow"
                      target="_blank"
                      rel="noopener noreferrer"
                      className="text-white"
                    >
                      <strong> Jeff Younger </strong>
                    </a>
                    is a public figure in the U.S. who became widely known due
                    to his legal and personal battles regarding the custody and
                    gender identity of his child, James Younger. The case drew
                    significant public attention because of disagreements
                    between Jeff and his ex-wife, Anne Georgulas, over how to
                    address James' gender identity.
                  </p>
                  <p
                    style={{
                      fontSize: "1.2rem",
                      lineHeight: "1.8",
                      textAlign: "justify",
                    }}
                  >
                    The body of James, son of
                    <a
                      href="https://x.com/JeffYoungerShow"
                      target="_blank"
                      rel="noopener noreferrer"
                      className="text-white"
                    >
                      <strong> @JeffYoungerShow </strong>
                    </a>
                    , was on the radar of a group of people with an evil mindset
                    who wanted to sacrifice this innocent kid to scientific
                    experimentation led by pharmaceutical mafias behind the
                    scenes with the help of individuals controlling the law.
                    This father, however, was of a different kind.
                  </p>
                  <p
                    style={{
                      fontSize: "1.2rem",
                      lineHeight: "1.8",
                      textAlign: "justify",
                    }}
                  >
                    With a never-give-up attitude toward his son, the father
                    began resisting his own wife and consequently had to lose
                    everything he had. He was exhausted, gagged, and drained
                    financially by the government, but he never surrendered. His
                    fight commenced in 2015 and is still ongoing. Any ordinary
                    human would have collapsed at this stage, but
                    <a
                      href="https://x.com/JeffYoungerShow"
                      target="_blank"
                      rel="noopener noreferrer"
                      className="text-white"
                    >
                      <strong> @JeffYoungerShow </strong>
                    </a>
                    has been fighting like never before.
                  </p>
                  <p
                    style={{
                      fontSize: "1.2rem",
                      lineHeight: "1.8",
                      textAlign: "justify",
                    }}
                  >
                    The case became a flashpoint in broader societal debates
                    around parental rights, gender-affirming care, and
                    transgender issues, sparking media coverage and political
                    involvement in Texas and beyond. Say no to their woke
                    agenda! This isn't about freedom of expression; this is
                    about a blatant attack directed at children and society led
                    by dark pharmaceutical agendas and their experimentation on
                    the innocents, the feminine superpower, and its crushing
                    effect on fathers like
                    <a
                      href="https://x.com/JeffYoungerShow"
                      target="_blank"
                      rel="noopener noreferrer"
                      className="text-white"
                    >
                      <strong> Jeff Younger </strong>
                    </a>
                    and the unfair treatment received especially by fathers in
                    the family court.
                  </p>
                  {/* <p
                    className="text-center"
                    style={{
                      fontWeight: "bold",
                      fontSize: "1.5rem",
                      color: "rgb(255 119 40)",
                    }}
                  >
                    LFG!!!
                  </p> */}
                  <div className="text-center mt-4">
                    <Button variant="outline-dark" size="lg">
                      <a
                        href="https://dexscreener.com/solana/enyvkesxxfeoy8wgpf9hedh7qnfbcxwo9awt3kjk8fyw"
                        target="_blank"
                        rel="noopener noreferrer"
                        style={{ textDecoration: "none", color: "white" }}
                      >
                        Join the Movement
                      </a>
                    </Button>
                  </div>
                </Col>
              </Row>
            </Col>
            <Col md={4}>
              <VideoPlayer />
            </Col>
          </Row>
        </Container>
      </div>
      <Container>
        <Row className="text-center mb-5 mt-5">
          <Col>
            <h1 className="display-4">Save James Campaign</h1>
            <p
              className="font-weight-bold"
              style={{
                fontSize: "1.2rem",
                lineHeight: "1.4",
                textAlign: "justify",
              }}
            >
              A group of people on the internet were closely observing the
              build-up and decided to create a token{" "}
              <a
                href="https://dexscreener.com/solana/enyvkesxxfeoy8wgpf9hedh7qnfbcxwo9awt3kjk8fyw"
                target="_blank"
                rel="noopener noreferrer"
                style={{ textDecoration: "none" }}
                className="text-white"
              >
                <p className="hvr-buzz-out mb-1">$SAVEJAMES</p>
              </a>{" "}
              to retell the verified version of the story for centuries to come.
              Those people turned out to be jeets on the Solana Ecosystem who
              then rugged the token for quick profit, indicating how evil any
              individual can be when it comes to money.
            </p>
            <p
              style={{
                fontSize: "1.2rem",
                lineHeight: "1.8",
                textAlign: "justify",
              }}
            >
              They used, humiliated, and mocked Jeff Younger by asking him to
              create a wallet and send some allocations. Jeff, along with his
              supporters, was unaware of that dark trick. Displaying Jeff's
              donation wallet openly on public X (Twitter), they continuously
              tagged Jeff in their posts showcasing the donation holding, while
              those thugs were pumping and dumping on his hardcore crypto
              supporters who were leading his voice on-chain on the Solana
              Blockchain.
            </p>
            <p
              style={{
                fontSize: "1.2rem",
                lineHeight: "1.8",
                textAlign: "justify",
              }}
            >
              Those supporters on-chain later turned out to be his in-person
              troops on all public speech platforms and took over the community
              after the initial group of people dumped over. The community never
              gave up and fought back against those bad actors. They loved James
              and children like him, vowed to carry on the legacy to higher
              grounds, and help Jeff get the justice he deserved. The real
              movement starts, and the internet starts shaking! LFG!
            </p>
            <p
              className="text-center"
              style={{
                fontWeight: "bold",
                fontSize: "1.5rem",
                color: "rgb(255 119 40)",
              }}
            >
              LFG!!!
            </p>
          </Col>
        </Row>

        <Container className="text-center py-5">
          <h2 className="text-light mb-4">Follow Us On:</h2>
          <Row className="justify-content-center">
            {links.map((link, index) => (
              <Col key={index} xs={12} sm={6} md={3} className="mb-3">
                <Button
                  variant={link.variant}
                  className="d-flex align-items-center justify-content-center w-100"
                  href={link.url}
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  {link.icon} <span className="ms-2">{link.name}</span>
                </Button>
              </Col>
            ))}
          </Row>
        </Container>
      </Container>
      <Container fluid>
        <LandscapeTabs />
      </Container>
      <Container className="p-4" fluid>
        <SaveJamesSection />
      </Container>
      <Container fluid>
        <h2 className="text-center">Some memories of James</h2>
        <GalleryLayout />
      </Container>
      <Container>
        <Card.Title className="text-center text-warning fw-bold fs-3 mb-4">
          HIGH PROFILE SUPPORT
        </Card.Title>

        <Row className="justify-content-center mt-4 pb-4">
          <Col md={6}>
            <Card className="shadow-lg bg-dark text-light">
              <Card.Body>
                {/* YouTube Links Section */}
                <div className="support-category mb-4 text-center">
                  <h3 className="text-secondary fw-semibold fs-5 mb-3">
                    YOUTUBE LINKS TO SAVEJAMES
                  </h3>
                  <Button
                    variant="danger"
                    className="d-flex align-items-center justify-content-center mx-auto"
                    onClick={() => navigate("/ytvideos")}
                  >
                    <FaYoutube className="me-2" size={20} />
                    Go to YouTube Links
                  </Button>
                </div>
              </Card.Body>
            </Card>
          </Col>
          <Col md={6}>
            <Card className="shadow-lg bg-dark text-light">
              <Card.Body>
                {/* Twitter Links Section */}
                <div className="support-category mb-4 text-center">
                  <h3 className="text-secondary fw-semibold fs-5 mb-3">
                    TWITTER LINKS TO SAVEJAMES
                  </h3>
                  <Button
                    variant="info"
                    className="d-flex align-items-center justify-content-center mx-auto"
                    onClick={() => navigate("/tweets")}
                  >
                    <FaTwitter className="me-2" size={20} />
                    Go to Twitter Links
                  </Button>
                </div>
              </Card.Body>
            </Card>
          </Col>
        </Row>
      </Container>
    </div>
  );
}

export default HomePage;
